import React from 'react';
import { Trophy } from 'lucide-react';

function Hero() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white/15 to-[#0dceda]/15 pointer-events-none" />
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex justify-center mb-6">
          <Trophy className="h-16 w-16 text-[#0dceda] animate-bounce" />
        </div>
        
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          <span className="bg-gradient-to-r from-white to-[#0dceda] text-transparent bg-clip-text animate-gradient">
            Complete Challenges.
          </span>
          <br />
          <span className="bg-gradient-to-r from-[#0dceda] to-white text-transparent bg-clip-text animate-gradient delay-150">
            Earn Credits.
          </span>
          <br />
          <span className="bg-gradient-to-r from-white to-[#0dceda] text-transparent bg-clip-text animate-gradient delay-300">
            Get V-Bucks.
          </span>
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          Join the ultimate Fortnite challenge platform. Complete daily challenges, earn credits, and exchange them for V-Bucks!
        </p>
        
        <button className="bg-[#0dceda] text-white px-8 py-4 rounded-full font-semibold text-lg transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#0dceda]/90">
          Start Earning Now
        </button>
      </div>
    </section>
  );
}

export default Hero;